export default __webpack_public_path__ + "static/media/group.686180a9.svg";